var vimeo_lite = (function( $ ) {

	var _init = function() {
		_fix_play_cursor();
		_remove_broken_placeholder();
	};

	/**
	 * Fixes the play button on vimeo lite to show a pointer cursor for usability. It's in the shadow dom so there's
	 * no easy way to change this by CSS alone.
	 */
	var _fix_play_cursor = function() {
		$('lite-vimeo').each(function() {
			this.shadowRoot.querySelector(".lvo-playbtn").setAttribute("style", "cursor: pointer");
		});
	};

	/**
	 * Vimeo seem to have changed how placeholders work and this is now causing a broken image icon to appear overlayed
	 * on videos so we need to remove the placeholder.
	 */
	var _remove_broken_placeholder = function() {
		$('lite-vimeo').each(function() {
			this.shadowRoot.querySelector("#fallbackPlaceholder").setAttribute("style", "display: none");
		});
	};

	$( _init );

	return {};

})( jQuery );

module.exports = vimeo_lite;